<template>
  <div class="floor-param-types">
    <CustomTable title="Параметры этажа" :rowsData="data" :columns="floorParamTypesColumns" :loading="loading"
      :show-search="true" :custom-body="true" :sticky-header="true" :showHeaderAdd="true" :on-add-click="openDialog"
      :checkbox="true" :checkbox-value="allSelected" @all-check-click="onAllCheckClick">
      <template #top-right v-if="selectedRows.length > 0">
        <CustomButton @click="openAddTypeModal(selectedRows)" style="width: auto; height: 40px; font-size: 12px;">
          Редактировать типы
        </CustomButton>
      </template>
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center">
            <CustomCheckbox :value="selectedRows.includes(props.row.floor_param_type_id)"
              @change="(value) => onRowCheckClick(props.row.floor_param_type_id, value)" />
          </custom-table-cell>
          <custom-table-cell align="center">
            {{ props.row.floor_param_type_id }}
          </custom-table-cell>

          <custom-table-cell align="left">
            {{ props.row.floor_param_type_name }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center">
            <div class="project-types-container">
              <div class="project-types-list">
                <div v-if="props.row.project_type_names && props.row.project_type_names.length > 0"
                  v-for="(typeName, index) in props.row.project_type_names" :key="index" class="project-type-item">
                  {{ typeName }}
                </div>
                <span v-else class="no-types">Нет типов</span>
              </div>
              <div class="edit-icon-wrapper">
                <q-icon name="edit" size="20px" class="edit-icon" @click="openAddTypeModal(props.row)">
                  <q-tooltip>Редактировать типы</q-tooltip>
                </q-icon>
              </div>
            </div>
          </custom-table-cell>

          <custom-table-cell align="left">
            {{ props.row.floor_param_type_code }}
          </custom-table-cell>

          <custom-table-cell align="center" style="width: 100px;">
            {{ props.row.weight ? props.row.weight + ' кг' : '' }}
          </custom-table-cell>

          <custom-table-cell align="center">
            <div class="color-display" :style="{ backgroundColor: props.row.floor_param_type_color }"></div>
          </custom-table-cell>

          <custom-table-cell align="left">
            <div class="params-display-container">
              <div class="param-item"><strong>Ширина:</strong> {{ props.row.param_name1 }}</div>
              <div class="param-item"><strong>Высота:</strong> {{ props.row.param_name2 }}</div>
              <div class="param-item"><strong>Доп. параметр:</strong> {{ props.row.is_has_relative ? 'Да' : 'Нет' }}
              </div>
            </div>
          </custom-table-cell>

          <custom-table-cell align="center">
            {{ props.row.unit_name }}
          </custom-table-cell>

          <custom-table-cell align="center">
            <q-icon name="edit" size="20px" class="edit-icon" @click="openDialog(props.row)">
              <q-tooltip>Редактировать</q-tooltip>
            </q-icon>
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <CustomIcon icon="trash" :approve-mode="true" :loading="!!deleteLoading[props.row.floor_param_type_id]"
              :approve="() => onDeleteSubmit(props.row.floor_param_type_id)" />
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>

    <q-dialog v-model="dialog" persistent>
      <q-card style="min-width: 650px; max-width: 700px;">
        <q-card-section class="dialog-header">
          <div class="text-h6">
            {{
              editForm.floor_param_type_id ?
                'Редактировать параметр этажа' :
                'Добавить параметр этажа'
            }}
          </div>
          <q-btn icon="close" flat round dense v-close-popup @click="cancelEdit" />
        </q-card-section>

        <q-separator />

        <q-card-section class="dialog-content">
          <div class="form-container">
            <div class="form-row">
              <div class="form-group flex-1">
                <label class="form-label">Наименование <span class="required">*</span></label>
                <q-input v-model="editForm.floor_param_type_name" outlined dense placeholder="Введите наименование" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group flex-1">
                <label class="form-label">Код <span class="required">*</span></label>
                <q-input v-model="editForm.floor_param_type_code" outlined dense placeholder="Введите код" />
              </div>

              <div class="form-group flex-1">
                <label class="form-label">Вес</label>
                <q-input v-model="editForm.weight" outlined dense placeholder="Введите вес" type="number" />
              </div>

              <div class="form-group" style="width: 150px;">
                <label class="form-label">Цвет</label>
                <div class="color-picker-wrapper">
                  <input v-model="editForm.floor_param_type_color" type="color" class="color-input" />
                  <div class="color-preview" :style="{ backgroundColor: editForm.floor_param_type_color }"></div>
                  <span class="color-value">{{ editForm.floor_param_type_color }}</span>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group flex-1">
                <label class="form-label">Параметр ширины <span class="required">*</span></label>
                <q-select v-model="editForm.param_id1" :options="filteredParams1" option-value="param_id"
                  option-label="param_name" emit-value map-options outlined dense use-input fill-input hide-selected
                  input-debounce="300" @filter="filterParams1" placeholder="Начните вводить для поиска...">
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">
                        Не найдено
                      </q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group flex-1">
                <label class="form-label">Параметр высоты <span class="required">*</span></label>
                <q-select v-model="editForm.param_id2" :options="filteredParams2" option-value="param_id"
                  option-label="param_name" emit-value map-options outlined dense use-input fill-input hide-selected
                  input-debounce="300" @filter="filterParams2" placeholder="Начните вводить для поиска...">
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">
                        Не найдено
                      </q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group flex-1">
                <label class="form-label">Единица измерения <span class="required">*</span></label>
                <q-select v-model="editForm.unit_id" :options="filteredUnits" option-value="unit_id"
                  option-label="unit_name" emit-value map-options outlined dense use-input fill-input hide-selected
                  input-debounce="300" @filter="filterUnits" placeholder="Начните вводить для поиска...">
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">
                        Не найдено
                      </q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group checkbox-group">
                <q-checkbox v-model="editForm.is_has_relative" label="Доп. параметр" color="primary" />
              </div>
            </div>

            <div v-if="!editForm.floor_param_type_id" class="form-row">
              <div class="form-group checkbox-group">
                <q-checkbox v-model="editForm.is_create_param" label="Создать параметр планировки" color="primary" />
              </div>
              <div v-if="editForm.is_create_param" class="form-group checkbox-group">
                <q-checkbox v-model="editForm.is_create_link" label="Привязать к параметру" color="primary" />
              </div>
            </div>
          </div>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right" class="dialog-actions">
          <q-btn flat label="Отмена" color="grey-7" v-close-popup @click="cancelEdit" class="q-px-lg" />
          <q-btn unelevated label="Сохранить" color="primary" @click="saveItem" :loading="saving" class="q-px-lg" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomSelect from "@/components/form/CustomSelect";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomIcon from "@/components/common/CustomIcon";
import { getFloorParamTypes, updateFloorParamType, getParams, getUnits, floorParamTypesColumns, deleteFloorParamType } from "./services";
import { MODAL_NAMES } from "@/constants";
import CustomButton from "@/components/common/CustomButton";
import { useAppStore } from "@/services/store/app";
import Clickable from "@/components/common/Clickable.vue";

export default {
  name: "FloorParamTypes",
  components: { CustomTable, CustomTableCell, CustomSelect, CustomIcon, CustomCheckbox, CustomButton, Clickable },
  data() {
    return {
      floorParamTypesColumns,
      data: [],
      loading: false,
      saving: false,
      dialog: false,
      editForm: {
        floor_param_type_id: null,
        floor_param_type_name: "",
        floor_param_type_code: "",
        floor_param_type_color: "#000000",
        param_id1: null,
        param_id2: null,
        is_has_relative: false,
        unit_id: null,
        is_create_param: false,
        is_create_link: false,
        weight: 0,
      },
      paramsOptions: [],
      unitsOptions: [],
      filteredParams1: [],
      filteredParams2: [],
      filteredUnits: [],
      deleteLoading: {},
      deleting: false,
      selectedRows: [],
      allSelected: false,
    };
  },
  async mounted() {
    await this.loadData();
    await this.loadOptions();
  },
  methods: {
    onRowCheckClick(floor_param_type_id, value) {
      if (value) {
        this.selectedRows.push(floor_param_type_id);
      } else {
        this.selectedRows = this.selectedRows.filter(id => id !== floor_param_type_id);
      }
      this.allSelected = this.selectedRows.length === this.data.length && this.data.length > 0;
    },
    onAllCheckClick(value) {
      this.allSelected = value;
      if (value) {
        this.selectedRows = this.data.map(item => item.floor_param_type_id);
      } else {
        this.selectedRows = [];
      }
    },
    openAddTypeModal(payload) {
      const rows = Array.isArray(payload) ? payload : [payload];
      const normalizedRows = rows
        .map((item) => {
          if (item && typeof item === "object") return item;
          return this.data.find((row) => row.floor_param_type_id === item);
        })
        .filter(Boolean);
      if (!normalizedRows.length) return;
      this.showModal(MODAL_NAMES.AddParamLink, {
        title: normalizedRows.length === 1 ? 'Типы линии' : `Типы линии (${normalizedRows.length})`,
        body: { rows: normalizedRows, isBulk: normalizedRows.length > 1 },
        onSubmit: () => this.reloadDataSilently()
      });
    },
    async reloadDataSilently() {
      const result = await getFloorParamTypes();
      if (!result) return;
      this.data = result || [];
    },
    async loadData() {
      this.loading = true;
      const result = await getFloorParamTypes();
      this.loading = false;
      if (!result) return;
      this.data = result || [];
    },

    async loadOptions() {
      const [paramsResult, unitsResult] = await Promise.all([
        getParams(),
        getUnits(),
      ]);
      if (!paramsResult || !unitsResult) return;
      this.paramsOptions = paramsResult || [];
      this.unitsOptions = unitsResult || [];

      // Инициализируем отфильтрованные списки
      this.filteredParams1 = this.paramsOptions;
      this.filteredParams2 = this.paramsOptions;
      this.filteredUnits = this.unitsOptions;
    },

    filterParams1(val, update) {
      update(() => {
        if (val === '') {
          this.filteredParams1 = this.paramsOptions;
        } else {
          const needle = val.toLowerCase();
          this.filteredParams1 = this.paramsOptions.filter(v =>
            v.param_name.toLowerCase().indexOf(needle) > -1
          );
        }
      });
    },

    filterParams2(val, update) {
      update(() => {
        if (val === '') {
          this.filteredParams2 = this.paramsOptions;
        } else {
          const needle = val.toLowerCase();
          this.filteredParams2 = this.paramsOptions.filter(v =>
            v.param_name.toLowerCase().indexOf(needle) > -1
          );
        }
      });
    },

    filterUnits(val, update) {
      update(() => {
        if (val === '') {
          this.filteredUnits = this.unitsOptions;
        } else {
          const needle = val.toLowerCase();
          this.filteredUnits = this.unitsOptions.filter(v =>
            v.unit_name.toLowerCase().indexOf(needle) > -1
          );
        }
      });
    },

    openDialog(item = null) {
      if (item) {
        // Редактирование существующего элемента
        this.editForm = { ...item };
      } else {
        // Добавление нового элемента
        this.resetEditForm();
      }

      // Сброс фильтров
      this.filteredParams1 = this.paramsOptions;
      this.filteredParams2 = this.paramsOptions;
      this.filteredUnits = this.unitsOptions;

      this.dialog = true;
    },

    async saveItem() {
      if (!this.editForm.floor_param_type_name?.trim()) {
        this.$q.notify({
          type: 'negative',
          message: 'Название параметра этажа обязательно для заполнения'
        });
        return;
      }
      if (!this.editForm.floor_param_type_code?.trim()) {
        this.$q.notify({
          type: 'negative',
          message: 'Код параметра этажа обязателен для заполнения'
        });
        return;
      }
      if (!this.editForm.param_id1) {
        this.$q.notify({
          type: 'negative',
          message: 'Параметр ширины обязателен для выбора'
        });
        return;
      }
      if (!this.editForm.param_id2) {
        this.$q.notify({
          type: 'negative',
          message: 'Параметр высоты обязателен для выбора'
        });
        return;
      }
      if (!this.editForm.unit_id) {
        this.$q.notify({
          type: 'negative',
          message: 'Единица измерения обязательна для выбора'
        });
        return;
      }

      this.saving = true;
      const result = await updateFloorParamType(this.editForm);
      this.saving = false;
      if (!result) return;

      this.$q.notify({
        type: 'positive',
        message: this.editForm.floor_param_type_id ? 'Параметр этажа успешно обновлен' : 'Параметр этажа успешно создан'
      });

      this.dialog = false;
      this.resetEditForm();
      await this.loadData();
    },

    cancelEdit() {
      this.dialog = false;
      this.resetEditForm();
    },

    resetEditForm() {
      this.editForm = {
        floor_param_type_id: null,
        floor_param_type_name: "",
        floor_param_type_code: "",
        weight: 0,
        floor_param_type_color: "#000000",
        param_id1: null,
        param_id2: null,
        is_has_relative: false,
        unit_id: null,
        is_create_param: false,
        is_create_link: false,
      };
    },
    async onDeleteSubmit(floor_param_type_id) {
      if (this.deleteLoading[floor_param_type_id]) return;
      this.deleting = true;
      this.deleteLoading = { ...this.deleteLoading, [floor_param_type_id]: true };
      const res = await deleteFloorParamType(floor_param_type_id);
      this.deleteLoading = { ...this.deleteLoading, [floor_param_type_id]: false };
      this.deleting = false;
      if (!res) return;
      this.data = this.data.filter(row => row.floor_param_type_id !== floor_param_type_id);
    },
  },
  setup() {
    const { showModal, closeModal } = useAppStore();
    return { showModal, closeModal };
  },
};
</script>

<style scoped lang="scss">
.floor-param-types {
  .color-display {
    width: 30px;
    height: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin: 0 auto;
  }

  .project-types-container {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    width: 100%;

    .project-types-list {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 4px;

      .project-type-item {
        padding: 4px 8px;
        background-color: #e3f2fd;
        border-left: 3px solid #1976d2;
        border-radius: 4px;
        font-size: 13px;
        line-height: 1.4;
        color: #1565c0;
        transition: all 0.2s ease;

        &:hover {
          background-color: #bbdefb;
          transform: translateX(2px);
        }
      }

      .no-types {
        color: #9e9e9e;
        font-style: italic;
        font-size: 13px;
      }
    }

    .edit-icon-wrapper {
      display: flex;
      align-items: center;

      .edit-icon {
        cursor: pointer;
        color: #1976d2;
        font-size: 18px;
        transition: all 0.2s ease;

        &:hover {
          color: #1565c0;
          transform: scale(1.1);
        }
      }
    }
  }

  .params-display-container {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .param-item {
      font-size: 13px;
      line-height: 1.4;

      strong {
        font-weight: 600;
        color: #555;
      }
    }
  }

  .edit-icon {
    cursor: pointer;
    color: #1976d2;
    transition: all 0.2s ease;

    &:hover {
      color: #1565c0;
      transform: scale(1.1);
    }
  }

  // Стили для модального окна
  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);

    .text-h6 {
      font-weight: 600;
      color: #2c3e50;
    }
  }

  .dialog-content {
    padding: 24px;
    max-height: 70vh;
    overflow-y: auto;
  }

  .dialog-actions {
    padding: 16px 24px;
    background-color: #f8f9fa;
  }

  // Стили для формы
  .form-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .form-row {
    display: flex;
    gap: 16px;
    align-items: flex-start;

    .flex-1 {
      flex: 1;
    }
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;

    &.checkbox-group {
      flex-direction: row;
      align-items: center;
      gap: 16px;
      padding-top: 4px;
    }
  }

  .form-label {
    font-weight: 500;
    font-size: 14px;
    color: #2c3e50;
    margin-bottom: 4px;

    .required {
      color: #e74c3c;
      margin-left: 2px;
    }
  }

  // Стили для выбора цвета
  .color-picker-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    background-color: #fff;
    transition: border-color 0.3s ease;

    &:hover {
      border-color: #1976d2;
    }

    .color-input {
      width: 40px;
      height: 32px;
      border: none;
      border-radius: 4px;
      cursor: pointer;

      &::-webkit-color-swatch-wrapper {
        padding: 0;
      }

      &::-webkit-color-swatch {
        border: 2px solid #d1d5db;
        border-radius: 4px;
      }
    }

    .color-preview {
      width: 32px;
      height: 32px;
      border: 2px solid #d1d5db;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }

    .color-value {
      font-family: 'Courier New', monospace;
      font-size: 13px;
      color: #6b7280;
      font-weight: 500;
    }
  }
}

// Глобальные стили для q-select в этом компоненте
:deep(.q-field) {
  .q-field__control {
    transition: all 0.3s ease;

    &:hover {
      border-color: #1976d2 !important;
    }
  }
}
</style>
